export enum ICON_MAP {
  plain = 'error_circle_filled',
  bold = 'error_circle_filled',
  blind = 'error_circle_filled',
  error = 'error_triangle_filled',
  warning = 'error_triangle_filled',
  info = 'error_circle_filled',
  plain_bigger = 'error_circle_filled',
}

export enum FILL_MAP {
  plain = 'icon-information',
  bold = 'icon-information',
  blind = 'icon-information',
  error = 'icon-error',
  warning = 'icon-warning',
  info = 'icon-information',
  plain_bigger = 'icon-information',
}

export enum BACKGROUND_TYPE {
  plain = 'var(--control-information)',
  bold = 'var(--control-information)',
  blind = 'var(--control-information)',
  error = 'var(--control-error)',
  warning = 'var(--control-warning)',
  info = 'var(--control-information)',
  plain_bigger = 'var(--control-information)',
}

export enum TEXT_COLOR {
  error = 'var(--text-body)',
  warning = 'var(--text-body)',
  info = 'var(--text-body)',
  plain = 'var(--text-body)',
  bold = 'var(--text-body)',
  blind = 'var(--text-body)',
  plain_bigger = 'var(--text-body)',
}

export const DEFAULT_NOTIFICATION_STYLE = 'info';
